













































































































import {Component, Mixins} from 'vue-property-decorator';
import WidgetDataTimerMixin from '@/mixins/WidgetDataTimerMixin';
import Card from '@c/Card.vue';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {PModuleType} from '@/enums/configs';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import Loading from '@c/controls/Loading.vue';
import TableLastDBBoundaryRecords from '@/components/system/developerInfo/TableLastDBBoundaryRecords.vue';
import {httpClient} from '@/api/baseApi';
import {EventName} from '@/views/dashboard/enums';
import {
  getErrorOccurredMessage,
  getDeviceChangedMessage,
  getBoundaryPassedMessage,
} from '@/views/dashboard/ProblemLogMessages';
import SimpleDialog from '@c/SimpleDialog.vue';
import measurementsModule from '@/store/modules/entities/measurementsModule';

@Component({
  components: {
    Card,
    TableLastDBBoundaryRecords,
    Loading,
    SimpleDialog,
  },
})
export default class PModuleEventBoundaryPassed extends Mixins(WidgetDataTimerMixin) {
  pmodule: PModuleWithMeasurements | null = null;
  moduleData: PModuleWithMeasurements | null = null;

  loading = true;
  error = false;

  dialog = false;

  daysCountModel: any = null;
  recordsCountModel: any = null;

  daysCount: any = [];
  recordsCount: any = [];

  data: any = [];

  protected getDataTimeout = 300;

  // Получить хранилище
  get apiStore(): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(
      ((this as any).$route.meta.type as any) as PModuleType,
    ) as any) as PModuleStoreModule;
  }

  async created() {
    try {
      const {data} = await this.apiStore.getById(this.$route.params.id);
      this.pmodule = data as PModuleWithMeasurements;
      this.moduleData = await this.getModuleData();

      measurementsModule.fetchAll();

      this.setDaysFilter();
      this.setRecordsFilter();
      this.refresh(async () => {
        await this.getData();
      });
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  setDaysFilter() {
    for (let i = 1; i <= 15; i++)
      this.daysCount.push({
        value: i,
        description:
          i == 1
            ? 'Последний день'
            : i == 2 || i == 3 || i == 4
            ? 'Последние ' + i + ' дня'
            : 'Последние ' + i + ' дней',
      });
    this.daysCountModel = 7;
  }

  async applySettings() {
    await this.getData();
  }

  setRecordsFilter() {
    for (let i = 10; i <= 150; i += 10)
      this.recordsCount.push({
        value: i,
        description: 'Последние ' + i + ' записей',
      });
    this.recordsCountModel = 20;
  }

  async getData() {
    const now = new Date();
    const today = Math.ceil(now.getTime() / 86400000) * 86400000;
    const startDate = today - this.daysCountModel * 24 * 60 * 60 * 1000 - 3 * 60 * 60;

    const params: any = {};
    params.start_date = startDate;
    if (this.recordsCountModel) params.limit = this.recordsCountModel;

    const {data} = await httpClient.get<[]>(`logs/common/${this.pmodule?.guid}`, {
      params: params,
    });

    let index = 0;
    const records = [];
    for (const element of (data as any)[0]) {
      const date = new Date(element[0]);
      index += 1;
      const content_data = JSON.parse(element[6]);
      records.push({
        index: index,
        timestamp: element[0],
        date: date ? date.toLocaleString() : '',
        eventName: element[3],
        level: element[4],
        code: element[5],
        content: content_data,
        moduleId: this.moduleData?.id,
        moduleName: this.moduleData?.name,
        module: this.pmodule?.type,
        showFullMessage: false,
      });
    }
    this.data = records.sort((x: any, y: any) => x.timestamp - y.timestamp).reverse();
  }

  async getModuleData() {
    const {data} = await httpClient.get(`modules/`, {
      params: {
        guids: JSON.stringify([this.pmodule?.guid]),
      },
    });
    return data[0];
  }

  getMessage(item: any) {
    switch (item.eventName) {
      case EventName.DeviceChanged:
        return getDeviceChangedMessage(item);
      case EventName.ErrorOccurred:
        return getErrorOccurredMessage(item);
      case EventName.BoundaryPassed:
        return getBoundaryPassedMessage(item);
      default:
        return item.eventName;
    }
  }

  getLevelColor(level: any) {
    if (level == 0) return 'green';
    else if (level == 1) return 'yellow';
    else if (level == 2) return 'orange';
    else if (level == 3) return 'red';
    else return '';
  }
}
